interface Props {
  left: number;
  top: number;
}

type HookReturnType =
  | 'ToolTipTopRight'
  | 'ToolTipTopLeft'
  | 'ToolTipBottomRight'
  | 'ToolTipBottomLeft';

/**
 * iPad application has form on the right half of the screen,
 * that's why we need to take into consideration tooltip position opening
 * on devices width larger than 767 (assuming that's iPad).
 * Tooltip is anyways hidden on width larger than 1024px (see ControlGroup component),
 * bcs there is no need for it on larger devices.
 * We are using Tooltip only for Mobiles and iPads.
 */
export const useToolTipPosition = ({ left, top }: Props): HookReturnType => {
  const leftBreakPoint = window.innerWidth > 767 ? 25 : 50;
  const topBreakpoint = 50;

  if (left > leftBreakPoint && top < topBreakpoint) {
    return 'ToolTipTopLeft';
  }
  if (left < leftBreakPoint && top > topBreakpoint) {
    return 'ToolTipBottomRight';
  }
  if (left >= leftBreakPoint && top >= topBreakpoint) {
    return 'ToolTipBottomLeft';
  }
  return 'ToolTipTopRight';
};
